module.exports = __webpack_public_path__ + "tables/media/orders.ceb4c09c.svg";